module.exports = __webpack_public_path__ + "static/media/iconChecked.a063e9af.svg";